import { SUPERADMINCLIENTLIST } from "../../ENVIRONMENT";

async function clientListSorting(token, currentPage, name, order) {
  // api for client sorting
  const response = await fetch(
    SUPERADMINCLIENTLIST + `?limit=6&page=${currentPage}&${name}=${order}`,
    {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${
          token ? token : sessionStorage.getItem("token")
        }`,
      },
    }
  );
  return response;
}
export { clientListSorting };
